import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Button, CircularProgress, Divider, Icon, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import EntityNameHeader from '../common/EntityNameHeader';
import { useEntityContext } from '../EntityContext';
import EntityRuleListRow from './EntityRuleListRow';
import EditEntityRuleDialog from '../dialogs/EditEntityRuleDialog';
const StyledDiv = styled.div `
  .header {
    display: flex;
    align-items: center;
    padding: 12px;
  }
  .MuiTableContainer-root {
    height: 100%;
  }
  .status-layout {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
  }
  .action-buttons {
    display: flex;
    margin-left: 8px;
    align-items: center;
  }
  .saving-status {
    /* margin-top: 3px; */
    /* min-height: 19px; */
    display: flex;
    justify-content: center;
    .save-label {
      margin-left: 8px;
    }
  }
`;
const EntityRuleList = ({ entity }) => {
    const { isQueued, isUpdating, trackChanges } = useEntityContext();
    const [rules, setRules] = useState((entity === null || entity === void 0 ? void 0 : entity.rules) || []);
    const [dragRule, setDragRule] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const sensors = useSensors(useSensor(PointerSensor));
    useEffect(() => {
        setRules(entity.rules || []);
    }, [entity]);
    return (React.createElement(StyledDiv, { className: 'entity-field-list' },
        React.createElement("div", { className: 'header' },
            React.createElement(EntityNameHeader, { entity: entity }),
            React.createElement("div", { className: 'status-layout' },
                React.createElement("div", { className: 'saving-status' }, (isQueued || isUpdating) && (React.createElement(React.Fragment, null,
                    React.createElement(CircularProgress, { size: 16 }),
                    React.createElement(Typography, { variant: 'caption', className: 'save-label' }, isQueued ? 'Queued...' : 'Saving...')))))),
        React.createElement(Divider, null),
        React.createElement(TableContainer, null,
            React.createElement(Table, { stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null),
                        React.createElement(TableCell, null, "Rule"),
                        React.createElement(TableCell, null, "Description"),
                        React.createElement(TableCell, null, "Delete"))),
                React.createElement(DndContext, { sensors: sensors, onDragStart: ({ active }) => {
                        const rule = rules.find(rule => active.id === rule.type);
                        rule && setDragRule(rule);
                    }, onDragEnd: ({ active, over }) => {
                        if (active.id === (over === null || over === void 0 ? void 0 : over.id))
                            return;
                        const sourceIndex = rules.findIndex(rule => active.id === rule.type);
                        const targetIndex = rules.findIndex(rule => (over === null || over === void 0 ? void 0 : over.id) === rule.type);
                        setRules(rules => {
                            return arrayMove(rules, sourceIndex, targetIndex);
                        });
                        trackChanges.move('rules', sourceIndex, targetIndex);
                    } },
                    React.createElement(SortableContext, { items: rules.map(rule => rule.type), strategy: verticalListSortingStrategy },
                        React.createElement(TableBody, null,
                            rules.map((rule, index) => (React.createElement(EntityRuleListRow, { key: rule.type, index: index, disabled: !entity.editable, rule: rule, entity: entity }))),
                            React.createElement(TableRow, null,
                                React.createElement(TableCell, { colSpan: 6 },
                                    React.createElement(Button, { variant: 'outlined', color: 'primary', disabled: !entity.editable, startIcon: React.createElement(Icon, null, "add"), onClick: () => setOpenDialog(true) }, "Add Rule"))))),
                    React.createElement(DragOverlay, { wrapperElement: 'tbody', style: { display: 'table' } }, dragRule && (React.createElement(EntityRuleListRow, { isDragging: true, index: rules.findIndex(rule => rule.type === dragRule.type), disabled: !entity.editable, rule: dragRule, entity: entity })))))),
        openDialog && (React.createElement(EditEntityRuleDialog, { open: true, entity: entity, onCancel: () => setOpenDialog(false), onChange: rule => {
                setOpenDialog(false);
                trackChanges.insert('rules', rule);
            } }))));
};
export default EntityRuleList;
//# sourceMappingURL=EntityRuleList.js.map